<!-- #region HTML -->
<template>
  <!-- #region Toolbar -->
  <md-toolbar>
    <!-- #region Logo -->
    <div class="md-title" style="flex: 1">
      <a href="https://eowpf.alc.co.jp">
        <img alt="ALC PRESS INC." src="@/assets/img/logo.svg" width="100%" v-if="!spMenuFlg" />
        <img alt="ALC PRESS INC." src="@/assets/img/logo-sp.svg" width="100%" v-if="spMenuFlg"
          v-on:click='toggleMenu' />
      </a>
    </div>
    <!-- #endregion -->

    <!-- #region Header Links -->
    <div class="header">
      <div v-if="signedIn === true">
        <ul>
          <li><md-button class="md-simple md-sm" to="/change-email">メールアドレス変更</md-button></li>
          <li><md-button class="md-simple md-sm" to="/change-password">パスワード変更</md-button></li>
          <li><md-button class="md-simple md-sm" to="/change-opt-in">メールマガジン等の配信設定</md-button></li>
          <li><md-button class="md-simple md-sm" to="/delete-account">アカウント削除</md-button></li>
          <li><md-button class="md-simple md-sm" href="https://eow-support.alc.co.jp/hc/ja"
              target="_blank">ヘルプ</md-button></li>
          <li><md-button class="md-simple md-sm" @click="signOut()">ログアウト</md-button></li>
        </ul>
      </div>
      <div v-else>
        <ul>
          <li><md-button class="md-simple md-sm" to="/signup">新規登録</md-button></li>
          <li><md-button class="md-simple md-sm" to="/forgot-password">パスワード再設定</md-button></li>
          <li><md-button class="md-simple md-sm" href="https://eow-support.alc.co.jp/hc/ja"
              target="_blank">ヘルプ</md-button></li>
          <li><md-button class="md-simple md-sm" to="/signin">ログイン</md-button></li>
        </ul>
      </div>
    </div>
    <!-- #endregion -->

    <!-- #region Mobile Menu Button -->
    <div class="sp-menu-btn" width="100%" v-on:click='toggleMenu'>
      <svg xmlns="http://www.w3.org/2000/svg" width="33" height="22" viewBox="0 0 33 22" fill="none" v-if='!spMenuFlg'>
        <line x1="33" y1="0.946289" x2="4.37114e-08" y2="0.946292" stroke="black" />
        <line x1="33" y1="20.9463" x2="4.37114e-08" y2="20.9463" stroke="black" />
        <line x1="33" y1="10.9463" x2="4.37114e-08" y2="10.9463" stroke="black" />
      </svg>
      <svg xmlns="http://www.w3.org/2000/svg" width="33" height="22" viewBox="0 0 33 22" fill="none" v-if='spMenuFlg'>
        <line x1="32.265" y1="0.870288" x2="0.264999" y2="20.8703" stroke="white" />
        <line x1="32.735" y1="20.8703" x2="0.735001" y2="0.870288" stroke="white" />
      </svg>
    </div>
    <!-- #endregion -->

    <!-- #region Mobile Menu -->
    <nav class="sp-menu-container">
      <div class="sp-menu" v-bind:class="{ 'show': spMenuFlg && clicked, 'hide': !spMenuFlg && clicked }">
        <div v-if="signedIn === true">
          <ul>
            <li><a href="/change-email">メールアドレス変更</a></li>
            <li><a href="/change-password">パスワード変更</a></li>
            <li><a href="/change-opt-in">メールマガジン等の配信設定</a></li>
            <li><a href="/delete-account">アカウント削除</a></li>
            <li><a href="https://eow-support.alc.co.jp/hc/ja" target="_blank">ヘルプ</a></li>
            <li><a @click="signOut()">ログアウト</a></li>
          </ul>
        </div>
        <div v-else>
          <ul>
            <li><a href="/signup">新規登録</a></li>
            <li><a href="/forgot-password">パスワード再設定</a></li>
            <li><a href="https://eow-support.alc.co.jp/hc/ja" target="_blank">ヘルプ</a></li>
            <li><a href="/signin">ログイン</a></li>
          </ul>
        </div>
      </div>
    </nav>
    <!-- #endregion -->
  </md-toolbar>
  <!-- #endregion -->
</template>
<!-- #endregion -->

<!-- #region Java Script -->

<script>
import { Auth } from 'aws-amplify';
export default {
  props: {
    signedIn: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      spMenuFlg: false,
      clicked: false,
    }
  },
  watch: {
    spMenuFlg(newVal) {
      if (newVal) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    signOut: async function () {
      try {
        await Auth.signOut({ global: true })
      } catch (error) {
      }
      this.$store.commit('clearAuthData')
      this.$emit('callSignout')
      this.closeMenuSP()
      this.$router.push({
        path: '/',
        query: { loggedOut: true },
      });
    },
    toggleMenu() {
      this.clicked = true;
      this.spMenuFlg = !this.spMenuFlg;
    },
    closeMenuSP: function () {
      this.spMenuFlg = false;
    },
    handleResize() {
      this.closeMenuSP();
    },
  },
}
</script>

<!-- #endregion -->

<!-- #region CSS -->

<style lang="scss" scoped>
/* #region General Styles */
.md-toolbar {
  background-color: var(--background-primary) !important;
  display: flex;
  height: var(--header-height);
  padding: 0 20px 0 16px;
  box-shadow: none;
  margin: 0;
  border: 0;
  border-bottom: 2px solid;
  border-image: var(--gradient-color);
  border-image-slice: 1;
}

.md-toolbar ul {
  line-height: 2em;
  padding: 0;
}

.md-toolbar li {
  display: inline;
  border-left: 1px solid var(--text-primary);
}

.md-toolbar li:first-child {
  border-left: none;
}

.md-title {
  z-index: 999;
}

.sp-menu-btn {
  display: none;
  width: 40px;
  height: 40px;
  padding: 10px 4px 10px 3px;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.sp-menu-container {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
  display: flex;
  justify-content: flex-end;
}

.sp-menu {
  background-color: var(--mobile-background-color);
  opacity: 0.9;
  width: 0;
  height: 100vh;
  position: absolute;
  overflow: auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.sp-menu.show {
  animation: fadeIn 0.5s forwards;
}

.sp-menu.hide {
  animation: fadeOut 0.5s forwards;
}

.sp-menu ul {
  margin: 0;
  max-height: 70vh;
  overflow-x: hidden;
}

.sp-menu li,
.sp-menu a {
  list-style: none;
  display: block;
  border-bottom: solid 1px #fff;
  width: 300px;
  text-align: left;
  font-size: 20px;
  line-height: 90px;
  color: var(--mobile-menu-color) !important;
}

.header {
  display: flex;
}

/* #endregion */

/* #region SP */
@media screen and (max-width: 768px) {
  .md-toolbar {
    padding-right: var(--card-horizontal-padding);
  }
}

@media screen and (max-height: 540px) {

  .sp-menu li,
  .sp-menu a {
    line-height: 70px;
  }
}

@media screen and (max-width: 961px) {
  .sp-menu-btn {
    display: flex;
  }

  .header {
    display: none;
  }
}

/* #endregion */

/* #region Animations */
@keyframes fadeIn {
  from {
    width: 0;
  }

  to {
    width: 100vw;
  }
}

@keyframes fadeOut {
  from {
    width: 100vw;
  }

  to {
    width: 0;
  }
}

/* #endregion */
</style>

<!-- #endregion -->